module.exports = __webpack_public_path__ + "static/media/logo.ce3edfb6.svg";